<template>
  <div class="upload-avatar">
    <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
      <h3>Drop files to upload</h3>
    </div>
    <div class="avatar-upload"  v-show="!edit">
      <div class="text-center p-2">
        <label for="avatar">
          <img ref="imagePreview" :src="files.length ? files[0].url : imageSrc"  class="" />
          <a v-if="editbutton" ref="editbutton" @click="editImage" class="image-edit-button btn btn-primary" href="javascript:"><i class="fa fa-crop"></i></a>
        </label>
      </div>
      <div class="text-center p-2">
        <file-upload
          extensions="gif,jpg,jpeg,png,webp"
          accept="image/png,image/gif,image/jpeg,image/webp"
          name="media"
          :inputId="inputId"
          class="btn btn-primary"
          post-action="/deck/media/store"
          :drop="!edit"
          v-model="files"
          @input-filter="inputFilter"
          @input-file="inputFile"
          ref="upload"
          :headers="{'X-CSRF-TOKEN': csrfToken}"
          >
          {{ uploadButtonLabel }}
        </file-upload>
      </div>
    </div>

    <div class="avatar-edit" v-show="files.length && edit">
      <div class="avatar-edit-image" v-if="files.length">
        <img ref="editImage" :src="files[0].url" />
      </div>
      <div class="text-center p-4">
        <button type="button" class="btn btn-secondary" @click.prevent="editCancel">Cancel</button>
        <button type="submit" class="btn btn-primary" @click.prevent="editSave">Crop Image</button>
      </div>
    </div>
  </div>
</template>
<style>
  .upload-avatar .avatar-upload .rounded-circle {
    width: 200px;
    height: 200px;
  }
  .upload-avatar .text-center .btn {
    margin: 0 .5rem;
  }
  .upload-avatar .avatar-edit-image {
    max-width: 100%;
    max-height: calc(100vh - 500px);
    text-align: center;
  }


  .upload-avatar .drop-active {
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    position: fixed;
    z-index: 9999;
    opacity: .6;
    text-align: center;
    background: #000;
  }

  .upload-avatar .drop-active h3 {
    margin: -.5em 0 0;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    font-size: 40px;
    color: #fff;
    padding: 0;
  }
  .upload-avatar img {
    display: block;
    /* This rule is very important, please don't ignore this */
    max-width: 100%;
  }
  .file-uploads{
    min-width: 160px;
  }
</style>


<script>
import Cropper from 'cropperjs'
import FileUpload from 'vue-upload-component'
import axios from 'axios'
export default {
  components: {
    FileUpload,
  },
  props: ['image','reference','editbutton','inputId','maxsize','uploadButtonText','newimagefromlib'],
  mounted(){
    this.csrfToken = $('meta[name="csrf-token"]').attr('content');
    if(!this.image){this.editbutton=false;}
    if(this.maxfilesize == null){
      this.maxfilesize = 15;
    }
  },
  data() {
    return {
      csrfToken : '',
      imageSrc : this.image,
      imageRef : this.reference,
      files: [],
      edit: false,
      cropper: false,
      imagefromlib: this.newimagefromlib,
      maxfilesize: this.maxsize,
      uploadButtonLabel: this.uploadButtonText ? this.uploadButtonText : 'Upload Replacement Image'
    }
  },

  watch: {
    newimagefromlib(value){

      var vm = this;

      axios({
        method: 'get',
        url: vm.newimagefromlib.src,
        responseType: 'blob'
          }).then(function(response){
               
               let img = response.data;
                   img.name = vm.newimagefromlib.src.substring(vm.newimagefromlib.src.lastIndexOf('/')+1);

               vm.inputFile(img);
               vm.$refs.upload.add(img);
               vm.edit = true;

          })
      
    },
    image(){
       this.$refs.imagePreview.src = this.image;
    },
    edit(value) {
      if (value) {
        this.$nextTick(function () {
          if (!this.$refs.editImage) {
            return
          }

          var cropper = new Cropper(this.$refs.editImage, {
            aspectRatio: 1.91 / 1,
            viewMode: 1,
          })
          this.cropper = cropper
        })
      } else {
        if (this.cropper) {
          this.cropper.destroy()
          this.cropper = false
        }
      }
    }
  },

  methods: {
      editImage(value){
      
      var vm = this;

      this.$emit('editingImage',value);

      axios({
        method: 'get',
        url: vm.$refs.imagePreview.src,
        responseType: 'blob'
          }).then(function(response){
               
               let img = response.data;

               

               var ext = '.png';


                   img.name = vm.$refs.imagePreview.src.substring(vm.$refs.imagePreview.src.lastIndexOf('/')+1)+ext;

                   


               vm.inputFile(img);
               vm.$refs.upload.add(img);
               vm.edit = true;

          })

    },
    editSave() {
    
      this.edit = false;

      let oldFile = this.files[0];      

      let binStr = atob(this.cropper.getCroppedCanvas().toDataURL(oldFile.type).split(',')[1])
      let arr = new Uint8Array(binStr.length)
      for (let i = 0; i < binStr.length; i++) {
        arr[i] = binStr.charCodeAt(i)
      }

      let file = new File([arr], oldFile.name, { type: oldFile.type })

      this.$refs.upload.update(oldFile.id, {
        file,
        type: file.type,
        size: file.size,
        active: true,
      });

    },
    editCancel(){
      this.edit = false;
      //this.$refs.upload.clear();
      this.$emit('stopEditingImage');
    },

    alert(message) {
      alert(message)
    },

    inputFile(newFile, oldFile, prevent) {     
      if (newFile && !oldFile) {
        this.$nextTick(function () {
          this.edit = true
        })
      }
      if (!newFile && oldFile) {
        this.edit = false;
      }     

      if (newFile && oldFile && !newFile.active && oldFile.active) {
        
        if (newFile.response.status && newFile.response.status == 'success') {
          
          // If successful then emit image url
          
          var newImageSrc = {reference:this.imageRef, src:newFile.response.url};

          this.$emit('newImageSrc',newImageSrc);
          this.$emit('stopEditingImage');

        }
      }

    },

    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {

        console.log(newFile.name);

        if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(newFile.name.split('?')[0])) {
          this.alert('Oops, we don\'t support this file format. Please upload images as JPG, PNG or GIF')
          return prevent();
        }

        if(newFile.size > this.maxfilesize*1024000){
          this.alert('The image you are trying to upload is too large, please use a smaller image (under '+ this.maxfilesize +' MB)');
          return prevent()
        }
      }

      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.url = ''
        let URL = window.URL || window.webkitURL
        if (URL && URL.createObjectURL) {

          newFile.url = URL.createObjectURL(newFile.file)

        }
      }
    }
  }
}
</script>
